import React, { useState } from "react";
import { Container, Row, Col, Card, ListGroup, Button, Badge } from "react-bootstrap";
import { CheckCircleFill } from "react-bootstrap-icons";
import BookDemo from "./BookDemo";
import "./schoolproduct.scss";
import { useNavigate } from "react-router-dom";

function Financeproduct() {
 const [show, setShow] = useState(false);
  const navigate = useNavigate();

  const [selectedProduct, setSelectedProduct] = useState("");
  
    const openDemo = (product) => {
     setSelectedProduct(product);
     setShow(true);
   };

  return (
    <section className="finance-product-section py-5 bg-light">
      <Container>

        {/* Section Header */}
        <div className="text-center mb-5">
          <Badge bg="success" className="px-3 py-2 mb-3">
            Finance & Loan Management Solution
          </Badge>
          <h2 className="fw-bold display-6">
            Uiplus Finance Management System
          </h2>
          <p className="text-muted">
            A secure and scalable digital platform designed for financial institutions,
            credit societies, and loan management companies.
          </p>
        </div>

        <Row className="align-items-center">

          {/* LEFT IMAGE */}
          <Col md={5} className="mb-4 text-center">
            <img
              src="/images/uiplus-finance-dashboard.png"
              alt="Uiplus Finance Management Dashboard"
              className="img-fluid rounded shadow-lg"
            />
          </Col>

          {/* RIGHT CONTENT */}
          <Col md={7}>
            <Card className="border-0 shadow-lg p-2 product-modern-card">
              <Card.Body>

                <h4 className="fw-bold mb-3">
                  Smart & Secure Financial Operations Platform
                </h4>

                <p className="text-muted" style={{textAlign:'justify'}}>
                  Uiplus Finance Application enables institutions to manage
                  loans, fixed deposits (FD), savings accounts, multi-branch
                  operations, financial reporting, and profit-loss analysis
                  from a centralized system.
                </p>

                <Row className="mt-4">

                  {/* Loan Features */}
                  <Col md={6}>
                    <h6 className="fw-bold mb-3">Loan Management</h6>
                    <ListGroup variant="flush">
                      <ListGroup.Item style={{padding:"5px"}}>
                        <CheckCircleFill className="text-success me-2" />
                        Loan Application & Approval Workflow
                      </ListGroup.Item>
                      <ListGroup.Item style={{padding:"5px"}}>
                        <CheckCircleFill className="text-success me-2" />
                        EMI Scheduling & Repayment Tracking
                      </ListGroup.Item>
                      <ListGroup.Item style={{padding:"5px"}}>
                        <CheckCircleFill className="text-success me-2" />
                        Interest & Processing Fee Customization
                      </ListGroup.Item>
                    </ListGroup>
                  </Col>

                  {/* FD Features */}
                  <Col md={6}>
                    <h6 className="fw-bold mb-3">Fixed Deposit (FD) Module</h6>
                    <ListGroup variant="flush">
                      <ListGroup.Item style={{padding:"5px"}}>
                        <CheckCircleFill className="text-success me-2" />
                        FD Account Creation & Management
                      </ListGroup.Item>
                      <ListGroup.Item style={{padding:"5px"}}>
                        <CheckCircleFill className="text-success me-2" />
                        Interest Rate Configuration & Renewal
                      </ListGroup.Item>
                      <ListGroup.Item style={{padding:"5px"}}>
                        <CheckCircleFill className="text-success me-2" />
                        FD Closure & Maturity Tracking
                      </ListGroup.Item>
                    </ListGroup>
                  </Col>

                </Row>

                {/* Highlight Box */}
                <div className="mt-4 p-3 rounded bg-white border-start border-4 border-success shadow-sm">
                  <strong>Why Choose Uiplus Finance?</strong>
                  <p className="mb-0 mt-2 text-muted" style={{textAlign:'justify'}}>
                    Enterprise-grade security, multi-branch support, automated financial reports,
                    user-friendly dashboards, and reliable technical support.
                  </p>
                </div>

                {/* CTA Buttons */}
                <div className="mt-4 d-flex flex-wrap gap-3">
                  <Button variant="success" onClick={() => openDemo("Finance Application")}>
                    Book Demo
                  </Button>

                  <Button
                    variant="outline-success"
                    onClick={() => navigate("/products/finance-management")}
                  >
                    View Details
                  </Button>
                </div>

              </Card.Body>
            </Card>
          </Col>

        </Row>

      </Container>

      {/* <BookDemo show={showDemo} handleClose={() => setShowDemo(false)} /> */}
        <BookDemo
          show={show}
          handleClose={() => setShow(false)}
          productName={selectedProduct}
        />
    </section>
  );
}

export default Financeproduct;